module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('main-banner', {
    attrs: {
      "image": 'src/assets/images/' + _vm.image
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "blue--text mt-5"
  }, [_vm._v(_vm._s(_vm.$t('pages.clients.wholesalers.title')))]), _vm._v(" "), _c('div', {
    staticClass: "mt-2 section-content",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('pages.clients.wholesalers.about'))
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "blue--text mt-5"
  }, [_vm._v(_vm._s(_vm.$t('pages.clients.wholesalers.products.title')))]), _vm._v(" "), _c('div', {
    staticClass: "mt-2 section-content",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('pages.clients.wholesalers.products.content'))
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "blue--text mt-5"
  }, [_vm._v(_vm._s(_vm.$t('pages.clients.wholesalers.contact.title')))]), _vm._v(" "), _c('div', {
    staticClass: "mt-2 section-content",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('pages.clients.wholesalers.contact.content'))
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-82e97338"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Wholesalers.vue
// module id = 441
// module chunks = 0